import { renderToString } from "react-dom/server";
import { getServerState } from "react-instantsearch";
async function getAlgoliaServerState(component) {
  try {
    return await getServerState(component, { renderToString });
  } catch (error) {
    console.error("An error occurred while fetching algolia server state:", error);
  }
}
export {
  getAlgoliaServerState
};
//# sourceMappingURL=get-algolia-server-state.js.map
